import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { TConditionalHelperDependencies } from '@kurtosys/types/helpers/TConditionalHelperDependencies.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';
import { IQueryOptionsResponse } from '@kurtosys/types/query/options/IQueryOptionsResponse.js';

import { commonUtils, helpers } from '../../common/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class ResponseQuery extends BaseQuery<IQueryOptionsResponse> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}

	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsResponse {
		const { key, keyQuery, options = {}, collectionItemConditional } = this.queryOptions;
		return {
			key,
			keyQuery,
			collectionItemConditional,
			...(options.response || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { responseContext: instance } = executionOptions;
		if (instance) {
			const { key, fullObject, collectionItemConditional } = this.options;
			// By default let the default behavior persists, then the conditional can override based on the conditions
			let matches = true;
			if (!commonUtils.isNullOrEmpty(collectionItemConditional)) {
				const conditionalHelperDependencies: TConditionalHelperDependencies = {
					queryClass: this.dependencies.queryClass,
				};
				const conditionalHelper = new helpers.ConditionalHelper(
					conditionalHelperDependencies,
					collectionItemConditional,
					this.translationHelper,
				);
				matches = conditionalHelper.matchesWithOptions({ instance, executionOptions });
			}
			if (matches) {
				if (fullObject) {
					return instance as any;
				}
				return commonUtils.get(instance, key);
			}
		}
		return undefined;
	}
}
